export default {"releaseVersion":"1.0.0","name":"production"}